import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { TypeaheadService } from '../../../services/typeahead.service';

@Component({
  selector: 'tt-delivery-customer',
  templateUrl: './delivery-customer.component.html',
  styleUrls: ['./delivery-customer.component.css']
})
export class DeliveryCustomerComponent implements OnInit {
    public deliveryCustomerKeyno: string;

    custNo;

    public edit?: Edit;

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private typeahead: TypeaheadService) {
        this.deliveryCustomerKeyno = this.stateService.getStateParams()['deliverycustomer_keyno'];
        this.custNo = this.stateService.getStateParams()['cust_no'];
    }

    private async loadEdit() {
        if (!!this.deliveryCustomerKeyno && !!this.custNo) {
            this.edit = (await this.datatask.Post(1074, {
                deliverycustomer_keyno: this.deliveryCustomerKeyno,
                cust_no: this.custNo
            }))[0];
        }
    }

    private async retrieveCustomer() {
        if (!this.edit) return;

        const response = (await this.datatask.Post(68, { cust_no: this.edit.delivery_cust_no }))[0];

        this.edit.delivery_cust_no = response?.cust_no;
        this.edit.delivery_address = response?.cust_address;
    }

    public searchCustomers = () => {
        if (this.edit?.search_contacts_only && this.edit.search_contacts_only === '1') {
            return this.typeahead.searchCustomer({
                cust_name: this.edit!.searchtext_customer,
                custtype: 'O',
                lastselect: 'SEARCH'
            });
        } else {
            return this.typeahead.searchCustomer({
                cust_name: this.edit!.searchtext_customer,
                custtype: 'C',
                lastselect: 'SEARCH'
            });
        }
    }

    public onCustomerSelected(event?: Item) {
        if (!this.edit) return;

        this.edit.delivery_cust_no = !!event ? '' + event.item_id : '0';
        this.edit.searchtext_customer = event?.item_name ?? '';

        if (this.edit.delivery_cust_no === '0' && this.edit.searchtext_customer === '') {
            this.edit.delivery_address = '';
        } else {
            this.retrieveCustomer();
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1075, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(2580, this.edit))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    page_heading: string;
    deliverycustomer_keyno: string;
    cust_no: string;
    searchtext_customer: string;
    delivery_cust_no: string;
    delivery_address: string;
    show_setting: string;
    search_contacts_only: string;
}
